module.exports = ".card-header-right {\n    z-index: 999;\n}\n\n.card.full-card {\n  position: fixed;\n  top: 56px;\n  z-index: 99999;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  left: 0;\n  border-radius: 0;\n  border: 1px solid #ddd;\n  width: 100vw;\n  height: calc(100vh - 56px);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/card/card.component.css
// module id = ./src/app/shared/card/card.component.css
// module chunks = main